module.exports = __webpack_public_path__ + "img/mt11.fa9f6fa7.jpg";